// extracted by mini-css-extract-plugin
export default {"form":"changepwd_form__jit6M","main":"changepwd_main__FNhjG"};